var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.calendarData != null)?_c('div',{staticStyle:{"padding":"10px"}},[_c('calendar',_vm._b({model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},'calendar',_vm.calendarData,false)),_vm._v(" "),_c('cancelaccept',{on:{"accept":_vm.accept,"cancel":_vm.cancel}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-017a25ff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/CalendarWidget/CalendarWidget.vue
// module id = null
// module chunks = 